import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'capitalizeOnlyFirstLetter'
})
export class CapitalizeFirstLetterPipe implements PipeTransform {
  transform(value: string, args?: any): any {
    if (!value || value.length < 2) {
      return value;
    }
    const firstLetter = value.charAt(0).toUpperCase();
    const remainingLetters = value.substr(1).toLowerCase()
    return `${firstLetter}${remainingLetters}`;
  }
}
